module.exports = __webpack_public_path__ + "static/elizabeth-profile-d1f02f79f6d24578a7ec6c9c47df1139.jpg";